import { ActivityLogSource, AuthenticationApplication } from "@/enums/enums";
import { generateCanvasFingerprint } from "@/helper/canvasFingerprintHelper";
import { AccessToken, CatchAPIService, GetTimezoneOffset, RefreshToken, SetHeaderService } from "@/helper/userHelper";
import { i18n } from "@/i18n";
import service from "../baseHttpService";
/* eslint @typescript-eslint/no-var-requires: "off" */
const qs = require("qs");

const RECAPTCHA_SITE_KEY =
  process.env.VUE_APP_RecaptchaEnterprise_ScoreSiteKey || process.env.VUE_APP_RecaptchaV3_SiteKey || "";
const RECAPTCHA_V2_SITE_KEY =
  process.env.VUE_APP_RecaptchaEnterprise_CheckboxSiteKey || process.env.VUE_APP_RecaptchaV2_SiteKey || "";

export interface GetAccessTokenParams {
  userName?: string;
  password?: string;
  userType?: number;
  iss?: string;
  token?: string;
  source?: ActivityLogSource;
  otp?: string;
  referenceOtp?: string;
  regenerateOtp?: boolean;
  twoFactorSecretKey?: string;
  recoveryCode?: string;
  recaptchaToken?: string;
  recaptchaVersion?: string;
}

class AuthenService {
  DoGetAccessToken(params: GetAccessTokenParams = {}) {
    const {
      userName,
      password,
      userType,
      iss,
      token = "",
      source = ActivityLogSource.None,
      otp,
      referenceOtp,
      regenerateOtp = false,
      twoFactorSecretKey,
      recoveryCode,
      recaptchaToken = "",
      recaptchaVersion = "",
    } = params;
    const { userAgent } = navigator;
    /* eslint-disable @typescript-eslint/camelcase */
    const requestData: any = {
      grant_type: "password",
      client_id: "line",
      client_secret: "lineSecret",
      scope: "payroll.api.full openid offline_access account.api.full export.api.full",
      username: userName,
      password: password,
      user_type: userType ?? 0,
      token: token,
      source: source,
      iss: iss,
      regenerate_otp: regenerateOtp,
    };

    if (recaptchaToken) {
      requestData.recaptcha_token = recaptchaToken;
    }
    if (recaptchaVersion) {
      requestData.recaptcha_version = recaptchaVersion;
    }
    const siteKeyToSend =
      recaptchaVersion === "v2" && RECAPTCHA_V2_SITE_KEY
        ? RECAPTCHA_V2_SITE_KEY
        : RECAPTCHA_SITE_KEY;
    if (siteKeyToSend) {
      requestData.recaptcha_sitekey = siteKeyToSend;
    }

    if (recoveryCode) {
      requestData.recovery_code = recoveryCode;
    } else if (otp) {
      requestData.otp = otp;
      if (twoFactorSecretKey) {
        requestData.two_factor_secret_key = twoFactorSecretKey;
        requestData.reference_otp = "";
      } else {
        requestData.reference_otp = referenceOtp || "";
      }
    }

    const data = qs.stringify(requestData);

    // สร้าง canvas fingerprint
    const canvasFingerprint = generateCanvasFingerprint();

    // สร้าง headers พร้อม canvas fingerprint
    const headers: any = {
      "Content-Type": "application/x-www-form-urlencoded",
      ApplicationId: AuthenticationApplication.PeakLineConnect,
      language: i18n.locale,
      timezoneOffset: GetTimezoneOffset(),
      "User-Agent": userAgent,
    };

    // เพิ่ม canvas fingerprint header
    if (canvasFingerprint) {
      headers["x-h-fgp"] = canvasFingerprint;
    }

    return service.peakAuthenticationAPI
      .post("/connect/token", data, {
        headers,
      })
      .then((res) => {
        return res;
      })
      .catch((err) => err.response);
  }
  DoGetNewAccessTokenByRefreshToken() {
    const { userAgent } = navigator;
    /* eslint-disable @typescript-eslint/camelcase */
    const data = qs.stringify({
      grant_type: "refresh_token",
      client_id: "line",
      client_secret: "lineSecret",
      refresh_token: RefreshToken(),
      userAgent,
    });

    // สร้าง canvas fingerprint
    const canvasFingerprint = generateCanvasFingerprint();

    // สร้าง headers พร้อม canvas fingerprint
    const headers: any = {
      "Content-Type": "application/x-www-form-urlencoded",
      ApplicationId: AuthenticationApplication.PeakLineConnect,
      language: i18n.locale,
      timezoneOffset: GetTimezoneOffset(),
      "User-Agent": userAgent,
    };

    // เพิ่ม canvas fingerprint header
    if (canvasFingerprint) {
      headers["x-h-fgp"] = canvasFingerprint;
    }

    return service.peakAuthenticationAPI
      .post("/connect/token", data, {
        headers,
      })
      .then((res) => {
        return res;
      })
      .catch((err) => err.response);
  }
  DoGetUserInfo() {
    const headers = {
      Authorization: `Bearer ${AccessToken()}`,
    };
    const params = {};
    return service.peakRealTimeAPIForUser
      .get("/api/User/GetUserInfoByUserId", { params, headers })
      .then((res) => {
        return res;
      })
      .catch((err) => CatchAPIService(err.response));
  }
  DoGetMerchantListByUserId(isUseMainDatabase = false) {
    const headers = SetHeaderService().headers;
    const params = { isUseMainDatabase: isUseMainDatabase };
    return service.peakRealTimeAPIForUser
      .get("/api/Merchant/GetMerchantListByUserId", { params, headers })
      .then((res) => {
        return res;
      });
  }
  DoGetSelectedMerchant(merchantId: number) {
    const headers = SetHeaderService().headers;
    const params = { merchantId: merchantId };
    return service.peakRealTimeAPIForUser
      .get("/api/v2/Merchant/GetSelectedMerchant", { params, headers })
      .then((res) => {
        return res;
      });
  }
}

export default new AuthenService();
